/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__candidate__model__SortByColumnEnum;

(function (jove__app__candidate__model__SortByColumnEnum) {
  jove__app__candidate__model__SortByColumnEnum["CREATED_AT"] = "created_at";
  jove__app__candidate__model__SortByColumnEnum["EMAIL"] = "email";
  jove__app__candidate__model__SortByColumnEnum["ORGANIZATION_ID"] = "organization_id";
})(jove__app__candidate__model__SortByColumnEnum || (jove__app__candidate__model__SortByColumnEnum = {}));